import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {TheRaveSound} from "../../sound/TheRaveSound";
import {TheRave} from "../../TheRave";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class AllReelStopped extends ReelStopPresentationController {
    constructor() {
        super('ReelStopPresentationController');
    }

    protected onReelStopped(data: IReelStateEventData): Promise<void> {
        if (data.reelId === 4) {
            TheRave.nearwinPresentation.reset(true);
        }
        if (data.reelId === TheRave.model.parsedGameData.lastLinkedReelId) {
            TheRave.reels.forEach((reel) => {
                reel.reelView.show();
                reel.reelView.resetMask(1);
            });
            TheRave.reelHighlighter.hide();
        }
        return super.onReelStopped(data);
    }
}